export default {
  namespaced: true,
  state: {
    procedimento: null,
    requerente: {
      nome: null,
      cpf: null
    },
    zerarCustas: false,
    ALTERACAO_ESTADO_CIVIL: false,
    INTEIRO_TEOR: false
  },
  getters: {
    getProcedimento: (state) => state.procedimento,
    getRequerente: (state) => state.requerente,
    getZerarCustas: (state) => state.zerarCustas,
    getAlteracaoEstadoCivil: (state) => state.ALTERACAO_ESTADO_CIVIL,
    getInteiroTeor: (state) => state.INTEIRO_TEOR
  },
  mutations: {
    UPDATE_PROCEDIMENTO (state, procedimento) {
      state.procedimento = procedimento
    },
    UPDATE_REQUERENTE (state, requerente) {
      state.requerente = requerente
    },
    UPDATE_ZERAR_CUSTAS (state, zerar) {
      state.zerarCustas = zerar
    },
    UPDATE_ALTERACAO_ESTADO_CIVIL (state, alteracaoEstadoCivil) {
      state.ALTERACAO_ESTADO_CIVIL = alteracaoEstadoCivil
    },
    UPDATE_INTEIRO_TEOR (state, inteiroTeor) {
      state.INTEIRO_TEOR = inteiroTeor
    }
  },
  actions: {
    updateProcedimento ({ commit }, procedimento) {
      commit('UPDATE_PROCEDIMENTO', procedimento)
    },
    updateRequerente ({ commit }, requerente) {
      commit('UPDATE_REQUERENTE', requerente)
    },
    updateZerarCustas ({ commit }, zerar) {
      commit('UPDATE_ZERAR_CUSTAS', zerar)
    },
    updateAlteracaoEstadoCivil ({commit}, alteracaoEstadoCivil) {
      commit('UPDATE_ALTERACAO_ESTADO_CIVIL', alteracaoEstadoCivil)
    },
    updateInteiroTeor ({commit}, inteiroTeor) {
      commit('UPDATE_INTEIRO_TEOR', inteiroTeor)
    }
  }
}